import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { VehicleProfile, Vehicle } from '../models/common-data-types';
import { CreateVehicleRequest } from '../models/request-data-types';
import { ApproveKYCDocumentPayload } from '../models/approve-document';

@Injectable({
    providedIn: 'root',
})
export class VehiclesService {
    constructor(private http: HttpClient) {}

    getVehicles(): Observable<Vehicle[]> {
        return this.http.get<Vehicle[]>(`/selfcare/vehicles`);
    }

    getQuotableVehicles(): Observable<Vehicle[]> {
        return this.http.get<Vehicle[]>(
            `/selfcare/motor-cover-options/quotable-vehicles`
        );
    }

    addVehicle(vehicle: CreateVehicleRequest): Observable<Vehicle> {
        return this.http.post<Vehicle>(`/selfcare/vehicles`, vehicle);
    }

    getVehicleProfile(vehicleId: string): Observable<VehicleProfile> {
        return this.http.get<VehicleProfile>(`/selfcare/vehicles/${vehicleId}`);
    }

    uploadDocument(
        vehicleId: string,
        payload: FormData
    ): Observable<VehicleProfile> {
        return this.http.post<VehicleProfile>(
            `/selfcare/vehicles/${vehicleId}/documents`,
            payload
        );
    }

    approveVehicleDocument(
        payload: ApproveKYCDocumentPayload,
        customerId: string,
        vehicleId: string,
        documentId: string
    ): Observable<VehicleProfile> {
        return this.http.post<VehicleProfile>(
            `/admin/customers/${customerId}/vehicles/${vehicleId}/documents/${documentId}/verification`,
            payload
        );
    }
}
